<template>
  <ul class="media-list files-block stack-media-on-mobile">
    <template v-for="(modelFile, fileIdx) in files.filter(f => {if (fileSlot) {return f.slot && f.slot.code === fileSlot.code} else {return showAll}})">
      <div class="col-sm-6-media mb-10" :class="{'condensed': condensed}">
        <li :key="fileIdx" class="media bordered mt-10">
          <div class="media-left">
            <template v-if="modelFile.file.image && imagesPreview">
              <img v-if="modelFile.file.image.is_public" :src="modelFile.file.image.preview" class="img-circle img-md">
              <img v-if="!modelFile.file.image.is_public" v-auth-img="modelFile.file.image.preview" class="img-circle img-md">
            </template>
            <template v-else>
              <img :src="require('@/assets/images/files/'+ fileType(modelFile.file.filename) +'-file.png')" class="img-md"/>
            </template>
            <!-- span class="badge bg-teal media-badge"><i class="icon-checkmark"></i></span -->
          </div>
          <div class="media-right media-middle">
            <ul class="icons-list text-nowrap">
              <li v-if="modelFile.file.is_public"><a :href="modelFile.file.preview" :download="modelFile.file.filename"><i class="icon-download10"></i></a></li>
              <li v-else><a :download="modelFile.file.filename" v-auth-file-download="fileService.makePrivateLink(modelFile.file.uid)"><i class="icon-download10"></i></a></li>
              <li v-if="canDeleteFile"><a @click.prevent="deleteFile(modelFile.file.id)"><i class="icon-cross2"></i></a></li>
            </ul>
          </div>
          <div class="media-body">
            {{modelFile.file.filename}}
            <!-- div class="media-annotation">19 minutes ago</div -->
          </div>
          <div class="media-overflow">
            <ul class="icons-list text-nowrap">
              <li v-if="modelFile.file.is_public"><a class="btn btn-small bg-success" :href="modelFile.file.preview" :download="modelFile.file.filename"><i class="icon-download10"></i></a></li>
              <li v-else><a class="btn btn-small bg-success" :download="modelFile.file.filename" v-auth-file-download="fileService.makePrivateLink(modelFile.file.uid)"><i class="icon-download10"></i></a></li>
              <li v-if="canDeleteFile"><a class="btn btn-small bg-danger" @click.prevent="deleteFile(modelFile.file.id)"><i class="icon-cross2"></i></a></li>
            </ul>
          </div>
        </li>
      </div>
    </template>
  </ul>
</template>

<script>
import fileServiceMixin from '@/helpers/mixins/_fileServiceMixin'
import initServiceMixin from '@/helpers/mixins/_initServiceMixin'

export default {
  name: 'ModelFilesList',
  props: {
    canDeleteFile: {
      type: [Boolean, Function],
      default: false
    },
    files: {
      type: Array,
      default: function () {
        return []
      }
    },
    fileSlot: {
      type: Object
    },
    showAll: {
      type: Boolean,
      default: false
    },
    imagesPreview: {
      type: Boolean,
      default: false
    },
    condensed: {
      type: Boolean,
      default: false
    }
  },
  mixins: [fileServiceMixin, initServiceMixin],

  data: function () {
    return {}
  },

  methods: {
    deleteFile (fileId) {
      this.$emit('deleteFile', fileId)
    },

    fileType (filename) {
      let type = 'text'
      let ext = filename.split('.').pop()
      switch (ext) {
        case 'ppt':
        case 'pptx':
          type = 'powerpoint'
          break
        case 'doc':
        case 'docx':
        case 'odt':
        case 'rtf':
          type = 'word'
          break
        case 'pdf':
          type = 'pdf'
          break
        case 'xls':
        case 'xlsx':
        case 'ods':
          type = 'excel'
          break
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'bmp':
        case 'tiff':
        case 'gif':
          type = 'image'
          break
      }
      return type
    }
  }
}
</script>

<style scoped>
.files-block .media:first-child {
  margin-top: 20px;
}

/* .files-block .media {
}

.files-block .media-left {
  float: left;
  width: 60px;
  height: 40px;
}

.files-block .media-right {
  float: right;
  width: 60px;
  height: 40px;
}*/

.files-block .media-body {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.files-block .media.bordered {
  padding: 7px 12px;
  margin-right: 5px;
  font-size: 13px;
  line-height: 1.5384616;
  color: #333;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ddd;
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .075);
  box-shadow: 0 1px 1px rgba(0, 0, 0, .075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
}

.files-block .media.bordered:hover {
  cursor: pointer;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .09);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .09);
}

.files-block .btn-small {
  padding: 4px 8px;
}

.col-sm-6-media.condensed {
  float: left;
  width: 105px;
  max-width: 105px;
  max-height: 100px;
}
</style>
